/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlSecurityProductItem } from './ControlSecurityProductItem';
import {
    ControlSecurityProductItemFromJSON,
    ControlSecurityProductItemFromJSONTyped,
    ControlSecurityProductItemToJSON,
} from './ControlSecurityProductItem';

/**
 * 
 * @export
 * @interface ControlSecurityProductsResponse
 */
export interface ControlSecurityProductsResponse {
    /**
     * 
     * @type {Array<ControlSecurityProductItem>}
     * @memberof ControlSecurityProductsResponse
     */
    security_products: Array<ControlSecurityProductItem>;
}

/**
 * Check if a given object implements the ControlSecurityProductsResponse interface.
 */
export function instanceOfControlSecurityProductsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "security_products" in value;

    return isInstance;
}

export function ControlSecurityProductsResponseFromJSON(json: any): ControlSecurityProductsResponse {
    return ControlSecurityProductsResponseFromJSONTyped(json, false);
}

export function ControlSecurityProductsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSecurityProductsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'security_products': ((json['security_products'] as Array<any>).map(ControlSecurityProductItemFromJSON)),
    };
}

export function ControlSecurityProductsResponseToJSON(value?: ControlSecurityProductsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'security_products': ((value.security_products as Array<any>).map(ControlSecurityProductItemToJSON)),
    };
}

